import { FC } from 'react';
import { FormProps } from './Form.types';
import { FormStyled } from './Form.styles';

const Form: FC<FormProps> = ({ children, ...formProps }) => {
  return (
    <FormStyled role="form" noValidate {...formProps}>
      {children}
    </FormStyled>
  );
};

export default Form;
